/**
 * Default cap applied to event-subcollection queries (resourceEvents,
 * triggerEvents, billingEvents, hikeEvents) when the caller does not pass an
 * explicit limit.
 *
 * Hikes can accumulate tens of thousands of event documents; streaming an
 * entire subcollection client-side hangs the dashboard. Combined with
 * `orderBy('createdAt', 'desc')` this returns the MOST RECENT N events
 * instead of the whole collection. Callers that need a different bound can
 * still pass an explicit `limit`.
 */
export const DEFAULT_EVENTS_QUERY_LIMIT = 500;
